import React, { Component } from 'react';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
      },
    flex: {
        flex: 1,
    },
});

const abEnvironment = new AbEnvironment();

/*
* This components formats a billing model for a consistent experience.
* It is simply a code reduction component.
*/
class SubscriptionBusinessModelDisplay extends Component {
   
    render() {

      let billingModel = "";
      if (this.props.usingAccountId === abEnvironment.getUserAttribute('a_id')) {
        billingModel = "I will pay at my expense.";
      } else {
        if (this.props.paymentOrder === 1 || this.props.paymentOrder === 0) {
          billingModel =  this.props.accountName + " will pay directly.";
        } else {
          billingModel = "I will pay at my expense.";
        }
      }
      

      let markup = '';
      if (this.props.appMarkupPercentage > 0) {
        markup = '+ Management fee (' + this.props.appMarkupPercentage + '%)';
      }
      if (this.props.appMarkupPercentage < 0) {
        markup = '- Discount (' + this.props.appMarkupPercentage + '%)';
      }
      let wholesaleDiscountPercentage = '';
      if (this.props.wholesaleDiscountPercentage > 0) {
        wholesaleDiscountPercentage = '(Bought at a wholesale discount of '  + this.props.wholesaleDiscountPercentage + '%)';
      }

      let passFees = '';
      if (this.props.passThroughFees === 1 || this.props.passThroughFees === "1") {
        passFees = '+ Pass payment fees to ' + this.props.accountName;
      }

      let showSubscription = 'Do not allow ' + this.props.accountName + ' to manage this subscription.';
      if (this.props.showSubscription === 1 || this.props.showSubscription === "1") {
        showSubscription = 'Allow ' + this.props.accountName + ' to manage this subscription.';
      }
 
      return (

        <Grid container style={{marginTop: 8}}>
          {((this.props.paymentOrder === 1 || this.props.paymentOrder === 0) && (this.props.usingAccountId !== abEnvironment.getUserAttribute('a_id'))) &&
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography variant="h6" style={{marginBottom: 16}}>
                    {billingModel} 
                  </Typography>
                </Grid>
                {markup  !== '' &&
                <Grid item xs={12}>
                  <Typography variant="body2">
                    {markup} 
                  </Typography>
                </Grid>
                }
                {passFees !== '' &&
                <Grid item xs={12}>
                  <Typography variant="body2">
                    {passFees} 
                  </Typography>
                </Grid>
                }
                {wholesaleDiscountPercentage !== '' &&
                <Grid item xs={12} style={{marginTop: '16px'}}>
                  <Typography variant="body2">
                    {wholesaleDiscountPercentage} 
                  </Typography>
                </Grid>
                }
              </Grid>
            </Grid>
          }
          {((this.props.paymentOrder === 2) || (this.props.usingAccountId === abEnvironment.getUserAttribute('a_id'))) &&
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography  variant="h6">
                    {billingModel} 
                  </Typography>
                </Grid>
                {showSubscription && (this.props.usingAccountId !== abEnvironment.getUserAttribute('a_id')) &&
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      {showSubscription} 
                    </Typography>
                  </Grid>
                }
              </Grid>
            </Grid>
          }
          
          

        </Grid>
      );

    }
}
  
export default withStyles(styleSheet)(SubscriptionBusinessModelDisplay);